#import "../../session-assignation/graphql/sessionCrudResult.fragment.graphql"

mutation preApproveAssignmentProposal(
  $scenarioId: ID!
  $originId: ID!
  $input: PreApproveAssignmentProposalInput!
) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    preApproveAssignmentProposal(input: $input) {
      errorCode
      proposalId
      state
      status
      unsupportedSessionId
      validation {
        ...SessionCrudResultFields
        __typename
      }
      __typename
    }
    __typename
  }
}
